import React from "react";
import { Avatar } from "@mui/material";
import taraLogo from "assets/images/tara_logo.png";

const TaraSidebarIcon = () => (
  <Avatar
    src={taraLogo}
    alt="TARA"
    sx={{
      width: 20,
      height: 20,
      flexShrink: 0,
      fontSize: "10px",
    }}
  />
);

export default TaraSidebarIcon;
